import type { MessageKey } from "./ru"

export const zhMessages = {
  "common.loading": "加载中...",
  "common.error": "错误",
  "common.back": "返回",
  "common.next": "下一步",
  "common.search": "搜索",
  "auth.loginErrorTitle": "登录错误",
  "auth.openViaTelegram": "请通过 Telegram 打开应用",
  "auth.telegramRequired": "应用必须通过 Telegram 打开",
  "auth.authorizationError": "授权错误",
  "device.rotatePortrait": "请将设备旋转为竖屏模式",
  "country.brazil": "巴西",
  "country.vietnam": "越南",
  "country.egypt": "埃及",
  "country.india": "印度",
  "country.indonesia": "印度尼西亚",
  "country.iran": "伊朗",
  "country.spain": "西班牙",
  "country.italy": "意大利",
  "country.kazakhstan": "哈萨克斯坦",
  "country.colombia": "哥伦比亚",
  "country.malaysia": "马来西亚",
  "country.mexico": "墨西哥",
  "country.nigeria": "尼日利亚",
  "country.pakistan": "巴基斯坦",
  "country.russia": "俄罗斯",
  "country.usa": "美国",
  "country.turkey": "土耳其",
  "country.uzbekistan": "乌兹别克斯坦",
  "country.ukraine": "乌克兰",
  "country.philippines": "菲律宾",
  "countrySelection.chooseCountry": "选择国家",
  "countrySelection.openAria": "选择国家",
  "languageSelection.chooseLanguage": "选择语言",
  "commercial.direction.autotrade": "汽车市场",
  "commercial.direction.insurance": "保险",
  "commercial.direction.pitstop": "维修服务",
  "commercial.direction.techhelp": "道路救援",
  "commercial.searchLabel": "BeepApp 搜索",
  "commercial.cityPlaceholder": "输入城市",
  "commercial.emptyTitle": "今天暂无优惠",
  "commercial.emptyLine1": "您的城市暂时还没有活跃的 BeepApp 合作伙伴",
  "commercial.emptyLine2": "我们正在寻找并接入合作伙伴",
  "commercial.emptyLine3": "新的优惠将自动显示在这里",
  "commercial.helperLine1": "输入您的城市以查看",
  "commercial.helperLine2": "可用优惠",
  "commercial.partnerPrompt": "想成为 BeepApp 合作伙伴吗？",
  "commercial.apply": "申请",
  "main.admin": "管理",
  "main.garage": "车库",
  "main.signalSent": "信号已发送",
  "main.partnerInviteUnavailable": "合作伙伴邀请暂不可用",
  "main.enterPlate": "输入车牌号",
  "main.searchError": "搜索错误",
  "main.signalSendError": "无法发送信号",
  "main.shareCardPrefix": "车牌卡片",
  "main.shareLinkError": "无法生成链接",
  "main.searchByPlateAria": "按车牌号搜索",
  "main.russianPlateAria": "俄罗斯车牌",
  "main.plateAria": "车牌",
  "main.findPlateAria": "查找车牌",
  "main.loadingVehicle": "正在加载车辆卡片…",
  "main.leaveSignal": "发送信号",
  "main.share": "分享",
  "signalSelection.chooseType": "选择信号类型",
  "signalSelection.category.attention": "个人",
  "signalSelection.category.road": "道路",
  "signalSelection.category.urgent": "紧急",
  "signalSelection.chooseSignal": "选择信号",
  "signalSelection.suggestOwn": "提出自己的选项",
  "signalConfirmation.title": "确认信号",
  "signalConfirmation.plateHeading": "检查车牌号",
  "signalConfirmation.signalHeading": "检查所选信号",
  "signalConfirmation.replyTitle": "允许在 Telegram 中回复",
  "signalConfirmation.replyBody": "启用后，车牌所有者可以通过 Telegram\n给您发送消息。只有您拥有 @username 时才能回复。\n是否回复由车牌所有者\n自行决定。",
  "signalConfirmation.consentText": "我确认该信号反映真实情况，\n不是垃圾信息，\n也不是虚假举报。",
  "signalConfirmation.warning": "发送后将无法\n修改该信号",
  "signalConfirmation.sending": "发送中…",
  "signalConfirmation.send": "发送",
  "partner.loadingAria": "加载中",
  "partner.title": "合作伙伴计划",
  "partner.offerLine1": "持续获得受邀用户全部付款的 30%",
  "partner.offerLine2": "适用于您邀请到 BeepApp 的用户",
  "partner.offerLine3": "通过 Telegram 联盟计划结算",
  "partner.connectUnavailable": "Telegram 联盟计划配置完成后即可连接。",
  "partner.connectTelegram": "在 Telegram 中连接",
  "partner.qrAria": "合作伙伴链接二维码",
  "partner.download": "下载",
  "partner.promoHeading": "创建个人优惠码",
  "partner.promoHelperLine1": "优惠码可激活额外一年的订阅",
  "partner.promoHelperLine2": "并帮助吸引用户",
  "partner.promoAria": "优惠码",
  "partner.affiliateHeading": "您的联盟链接",
  "partner.affiliateHelper": "保存链接以创建个人二维码",
  "partner.affiliateAria": "联盟链接",
  "partner.qrNoteLine1": "二维码可以放在您的车辆上，",
  "partner.qrNoteLine2": "也可以用于社交媒体和广告材料",
  "partner.save": "保存",
  "partner.reset": "重置",
  "partner.resetConfirm": "重置已保存的联盟链接？优惠码仍将保留。",
  "partner.promoFormatError": "优惠码必须包含 4 到 15 个字符。",
  "partner.affiliateHostError": "仅允许使用 t.me 或 telegram.me 链接。",
  "partner.affiliatePathError": "链接中不包含 Telegram 路径。",
  "partner.affiliateFormatError": "联盟链接无效。",
  "partner.loadError": "加载错误",
  "partner.checkInputError": "请检查输入的信息",
  "garageActivation.promoInvalid": "优惠码无效",
  "garageActivation.plateOccupied": "该车牌已被关联",
  "garageActivation.activateError": "无法激活车库",
  "garageEntry.loadJournalError": "无法加载行车日志",
  "garageEntry.loadStatusesError": "无法加载状态",
  "garageEntry.activationSuccess": "车库已成功激活",
  "garageEntry.plateAttached": "车牌已关联",
  "garageEntry.attachError": "无法关联车牌",
  "garageEntry.activationNote": "激活您的车库",
  "garageSheet.activationTitle": "车库激活",
  "garageSheet.plateHelper": "输入车辆车牌号",
  "garageSheet.promoHelper": "您有优惠码吗？",
  "garageSheet.cleanBonusLine1": "激活后 1 小时内",
  "garageSheet.cleanBonusLine2": "可免费使用“Clean Start”",
  "garageSheet.activationFor": "激活期限",
  "garageSheet.cost": "费用",
  "garageSheet.ownerConsentLine1": "我确认自己是",
  "garageSheet.ownerConsentLine2": "所填写车牌对应车辆的",
  "garageSheet.ownerConsentLine3": "所有者。",
  "garageSheet.processing": "处理中...",
  "garageSheet.attach": "关联",
  "garageSheet.pay": "支付",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "停用车库",
  "garageLifecycle.cleanWarningLine1": "车牌历史将被删除，",
  "garageLifecycle.cleanWarningLine2": "且无法恢复！",
  "garageLifecycle.deactivateWarningLine1": "停用后，将无法继续使用",
  "garageLifecycle.deactivateWarningLine2": "车库的活跃功能",
  "garageLifecycle.willBeDeleted": "将被删除",
  "garageLifecycle.cleanRemovedLine1": "• 行车日志中的所有记录",
  "garageLifecycle.cleanRemovedLine2": "• 已接收信号的历史",
  "garageLifecycle.cleanRemovedLine3": "• 公开信号计数",
  "garageLifecycle.cleanRemovedLine4": "  车牌卡片上的计数",
  "garageLifecycle.willRemain": "将被保留",
  "garageLifecycle.cleanPreservedLine1": "• 车牌与车库的关联",
  "garageLifecycle.cleanPreservedLine2": "• 剩余激活期限",
  "garageLifecycle.cleanPreservedLine3": "• 已选择的车牌状态",
  "garageLifecycle.cleanPreservedLine4": "• 车牌卡片总浏览量",
  "garageLifecycle.freeFirstHour": "首小时免费",
  "garageLifecycle.willBecomeUnavailable": "将无法使用",
  "garageLifecycle.deactivateRemovedLine1": "• 行车日志",
  "garageLifecycle.deactivateRemovedLine2": "• 选择和使用车牌状态",
  "garageLifecycle.deactivateRemovedLine3": "• 您将自动退出 AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• 汽车市场",
  "garageLifecycle.deactivateRemovedLine5": "• 保险",
  "garageLifecycle.deactivateRemovedLine6": "• 维修服务",
  "garageLifecycle.deactivateRemovedLine7": "• 道路救援",
  "garageLifecycle.deactivateRemovedLine8": "• 车牌将与车库解除关联",
  "garageLifecycle.willRemainAvailable": "仍可使用",
  "garageLifecycle.deactivatePreservedLine1": "• 同行者",
  "garageLifecycle.deactivatePreservedLine2": "• 调度员",
  "garageLifecycle.deactivatePreservedLine3": "• 车牌搜索和查看",
  "garageLifecycle.deactivatePreservedLine4": "  公开车辆卡片",
  "garageLifecycle.deactivatePreservedLine5": "• 可随时重新",
  "garageLifecycle.deactivatePreservedLine6": "  激活车库",
  "garageLifecycle.cleanConsentLine1": "我同意删除",
  "garageLifecycle.cleanConsentLine2": "该车牌的全部历史记录，",
  "garageLifecycle.cleanConsentLine3": "且无法恢复。",
  "garageLifecycle.deactivateConsentLine1": "我确认停用车库并",
  "garageLifecycle.deactivateConsentLine2": "终止访问所有",
  "garageLifecycle.deactivateConsentLine3": "活跃车库功能。",
  "garageLifecycle.clean": "清除",
  "garageLifecycle.deactivate": "停用",
} satisfies Record<MessageKey, string>
